import { render } from "./ListClient.vue?vue&type=template&id=4a10ea26&scoped=true"
import script from "./ListClient.vue?vue&type=script&lang=js"
export * from "./ListClient.vue?vue&type=script&lang=js"

import "./ListClient.vue?vue&type=style&index=0&id=4a10ea26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a10ea26"]])

export default __exports__